import axios from 'axios';

export default {
  create(data) {
    return axios.post('/v1/budgets', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  parse(data) {
    return axios.post('/v1/budgets/parse', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  getDashboard(params = {}) {
    return axios.get('/v1/budgets/dashboard', {
      params
    });
  },
  getDashboardBO(params = {}) {
    return axios.get('/v1/budgets/dashboard/budget-owner', {
      params
    });
  },
  getHouse(params = {}) {
    return axios.get('/v1/budgets/houses', { params });
  },
  getEntity(params = {}) {
    return axios.get('/v1/budgets/entities', { params });
  },
  getBrand(params = {}) {
    return axios.get('/v1/budgets/brands', { params });
  },
  getOwner(params = {}) {
    return axios.get('/v1/budgets/budget-owners', { params });
  },
  getTemplate() {
    return axios.get('/v1/budgets/template', {
      responseType: 'blob'
    });
  },
  // get budget by advance filter
  getBudgetReport(params = {}) {
    return axios.get('/v1/budgets/report', { params });
  },
  getBudgetReportDetail(params = {}) {
    return axios.get('/v1/budgets/report/detail', { params });
  },
  getBudgetDetailTaxo(params = {}) {
    return axios.get('/v1/budgets/report/detail/taxonomy', { params });
  }
};
